export default {
  qInfo: { qType: 'visualization' },
  qHyperCubeDef: {
    qDimensions: [
      // {
      //   qDef: {
      //     qFieldDefs: ['key_report_year'],
      //     qFieldLabels: ['keyReportYear'],
      //     qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }],
      //   },
      //   qNullSuppression: true,
      // },
      {
        qDef: {
          qFieldDefs: ['School Name (Report Type)'],
          qFieldLabels: ['schoolReport'],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['Abbreviated School Name (Report Type)'],
          qFieldLabels: ['schoolNameAbbrev'],
          qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['slug_report'],
          qFieldLabels: ['slugReport'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['ULCS Code'],
          qFieldLabels: ['ulcs'],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['Current Network'],
          qFieldLabels: ['network'],
        },
        qNullSuppression: true,
      },
      {
        qDef: {
          qFieldDefs: ['Sector'],
          qFieldLabels: ['sector'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['Grades Served'],
          qFieldLabels: ['gradesServed'],
        },
        qNullSuppression: false,
      },
      // {
      //   qDef: {
      //     qFieldDefs: ['PersonName_SchoolLeader'],
      //     qFieldLabels: ['schoolLeader'],
      //   },
      //   qNullSuppression: false,
      // },
      // {
      //   qDef: {
      //     qFieldDefs: ['street_address'],
      //     qFieldLabels: ['address'],
      //   },
      //   qNullSuppression: false,
      // },
      // {
      //   qDef: {
      //     qFieldDefs: ['phonenumber'],
      //     qFieldLabels: ['phonenumber'],
      //   },
      //   qNullSuppression: false,
      // },
      // {
      //   qDef: {
      //     qFieldDefs: ['website'],
      //     qFieldLabels: ['website'],
      //   },
      //   qNullSuppression: false,
      // },
      {
        qDef: {
          qFieldDefs: ['report_type_code'],
          qFieldLabels: ['report'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['Admission Type'],
          qFieldLabels: ['admissiontype'],
        },
        qNullSuppression: true,
      },
      // {
      //   qDef: {
      //     qFieldDefs: ['turnaround'],
      //     qFieldLabels: ['turnaround'],
      //   },
      //   qNullSuppression: true,
      // },
    ],
    qMeasures: [
      {
        qDef: {
          qDef: '$(v_only(score, goals, cy))',
          qLabel: 'tierOverallCY',
        },
      },
    ],
    qInitialDataFetch: [{ qWidth: 20, qHeight: 500 }],
  },
}
